import Stack from '@mui/material/Stack'
import usePaymentStep from '../../../hooks/usePaymentStep'
import { MoovyStyle } from '../../../styles/theme'
import Failure from './failure'
import Success from './success'

const StepFinish = () => {
  const [currentPaymentStep, _setCurrentPaymentStep] = usePaymentStep()
  return (
    <>
      <Stack
        spacing={MoovyStyle.rowSpacing}
        direction="column"
        alignItems="center"
        marginTop={MoovyStyle.rowSpacing}
      >
        {currentPaymentStep === 'FINISH' ? <Success /> : <Failure />}
      </Stack>
    </>
  )
}

export default StepFinish
